import logo from "./logo.svg";
import "./App.css";
import Routers from "./routers/Routers";

function App() {
  return (
    <>
      <Routers></Routers>
    </>
  );
}

export default App;
